import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';

@Component({
  selector: 'app-nofesh-admin-reservations',
  templateUrl: './nofesh-admin-reservations.component.html',
  styleUrls: ['./nofesh-admin-reservations.component.css']
})
export class NofeshAdminReservationsComponent implements OnInit {

  constructor(private router: Router,
              private userMessagesService: UserMessagesService) { }

  ngOnInit() 
  {
    // Component to delete
  }

  /*
  uniteSingles()
  {
    this.router.navigateByUrl("/admin/nofesh-admin/singles-unite")
  }
  
  back()
  {
    this.router.navigateByUrl("/admin/nofesh-admin/nofesh-admin-home");
    this.userMessagesService.clearAll();
  }
  hamtanaorbitul()
  {
    this.router.navigateByUrl("/admin/nofesh-admin/hamtanaorbitul")
  }
  */
}
